import Raven from 'raven-js';
const HUBSPOT_INTERNAL_PORTAL = 53;
const DRAFTS_SEGMENT = 'drafts';
const MAX_ATTRIBUTION_VALUE_LENGTH = 256;

// Tracking params sent with the usage event, mapped to their event property names
const TRACKING_PARAM_PROPERTIES = {
  source_app: 'sourceApp',
  utm_source: 'utmSource',
  utm_medium: 'utmMedium',
  utm_campaign: 'utmCampaign',
  utm_term: 'utmTerm',
  utm_content: 'utmContent',
  meeting_campaign: 'meetingCampaign'
};
const QUERY_PARAM_PROPERTIES = {
  meeting_origin_53: 'url'
};
const EMAIL_PATTERN = /[^\s@]+@[^\s@]+\.[^\s@]+/;
const URL_PATTERN = /^[a-z][a-z0-9+.-]*:\/\//i;
const LONG_DIGIT_RUN_PATTERN = /\d{9,}/;
const looksLikePii = value => EMAIL_PATTERN.test(value) || URL_PATTERN.test(value) || LONG_DIGIT_RUN_PATTERN.test(value);
const stripUrlQueryString = value => {
  try {
    const parsed = new URL(value);
    return `${parsed.origin}${parsed.pathname}`;
  } catch (e) {
    return value;
  }
};
const removeDraftsSegment = segments => {
  const draftsIndex = segments.findIndex(segment => segment.toLowerCase() === DRAFTS_SEGMENT);
  if (draftsIndex === -1) {
    return {
      segments
    };
  }
  return {
    segments: [...segments.slice(0, draftsIndex), ...segments.slice(draftsIndex + 2)],
    contactIdSegment: segments[draftsIndex + 1],
    precedingSegment: draftsIndex > 0 ? segments[draftsIndex - 1] : undefined
  };
};
export const getTrackingParamsAttribution = trackingParams => {
  const attribution = {};
  Object.entries(TRACKING_PARAM_PROPERTIES).forEach(([key, propertyName]) => {
    const value = trackingParams[key];
    if (value) {
      const stringValue = String(value);
      if (!looksLikePii(stringValue)) {
        attribution[propertyName] = stringValue.slice(0, MAX_ATTRIBUTION_VALUE_LENGTH);
      }
    }
  });
  return attribution;
};
export const getUrlAttributionParams = ({
  slug
}) => {
  const attribution = {};
  try {
    const {
      segments
    } = removeDraftsSegment((slug || '').split('/').filter(Boolean));
    const meetingSlug = segments.join('/');
    if (meetingSlug) {
      attribution.slug = meetingSlug;
    }
    const {
      contactIdSegment: pathContactId,
      precedingSegment: pathPortal
    } = removeDraftsSegment(window.location.pathname.split('/').filter(Boolean));
    if (pathPortal === String(HUBSPOT_INTERNAL_PORTAL) && pathContactId && /^\d+$/.test(pathContactId)) {
      attribution.contactId = pathContactId;
    }
    new URLSearchParams(window.location.search).forEach((value, key) => {
      if (value && Object.prototype.hasOwnProperty.call(QUERY_PARAM_PROPERTIES, key)) {
        const strippedValue = stripUrlQueryString(value);
        if (!EMAIL_PATTERN.test(strippedValue) && !LONG_DIGIT_RUN_PATTERN.test(strippedValue)) {
          attribution[QUERY_PARAM_PROPERTIES[key]] = strippedValue.slice(0, MAX_ATTRIBUTION_VALUE_LENGTH);
        }
      }
    });
  } catch (e) {
    Raven.captureException(e, {
      extra: {
        message: 'unable to extract url attribution params for meetings usage event'
      }
    });
  }
  return attribution;
};